import { useSupervisorBodyData } from '../reports/SupervisorHooks';
import { ReportsBody } from '../reports/ReportsBody';

export const CubicleOverview = () => {
  const supervisorBodyData = useSupervisorBodyData();
  return <ReportsBody {...supervisorBodyData} />;
};
